<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[999] flex items-center justify-center bg-black/40 px-4"
    style="top: -64px; height: calc(100% + 64px);"
  >
    <div class="w-full max-w-2xl rounded-xl bg-white shadow-xl">
      <div class="flex items-center justify-between border-b border-neutral-200 px-6 py-4">
        <h2 class="text-lg font-semibold text-neutral-800">
          Enviar solicitud - {{ inviteGroupName }}
        </h2>
        <button
          class="text-neutral-400 hover:text-neutral-600"
          @click="$emit('close')"
        >
          ✕
        </button>
      </div>

      <div class="px-6 py-5 space-y-4">
        <p class="text-sm text-neutral-600">
          Envia solicitudes a estudiantes para unirse a tus grupos.
        </p>

        <div class="rounded-lg border border-neutral-200 p-4 bg-neutral-50">
          <label class="block text-sm font-medium text-neutral-700 mb-2">
            Añadir Alumnos
          </label>
          <input
            :value="inviteEmails"
            type="text"
            placeholder="Ingresa correos electronicos separados por comas..."
            class="w-full rounded-md border border-neutral-300 px-3 py-2 text-sm text-neutral-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            @input="emitUpdate('inviteEmails', $event.target.value)"
          />
          <p class="text-xs text-neutral-500 mt-2">
            Ejemplo: julia.perez@email.com, juan.lopez@email.com
          </p>

          <!-- <div class="mt-3">
            <label class="block text-sm font-medium text-neutral-700 mb-2">
              O sube un archivo CSV con la lista de correos
            </label>
            <input
              type="file"
              accept=".csv"
              class="block w-full text-sm text-neutral-600 file:mr-3 file:rounded-md file:border-0 file:bg-blue-50 file:px-3 file:py-2 file:text-sm file:font-medium file:text-blue-700 hover:file:bg-blue-100"
            />
          </div> -->

          <label class="block text-sm font-medium text-neutral-700 mt-4 mb-2">
            Mensaje (Opcional)
          </label>
          <input
            :value="inviteMessage"
            type="text"
            placeholder="Puedes agregar un mensaje personalizado..."
            class="w-full rounded-md border border-neutral-300 px-3 py-2 text-sm text-neutral-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            @input="emitUpdate('inviteMessage', $event.target.value)"
          />
        </div>

        <!-- <div class="rounded-lg border border-neutral-200 p-4">
          <label class="block text-sm font-medium text-neutral-700 mb-2">
            O comparte este enlace:
          </label>
          <div class="flex gap-2">
            <input
              type="text"
              :value="inviteLink"
              readonly
              class="w-full rounded-md border border-neutral-300 px-3 py-2 text-sm text-neutral-700 bg-neutral-50"
            />
            <button
              class="rounded-md bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700"
              @click="$emit('copy-invite-link')"
            >
              Copiar Enlace
            </button>
          </div>

          <div class="flex items-center gap-2 mt-4">
            <input
              type="checkbox"
              :checked="protectInviteCode"
              id="protect-invite"
              class="h-4 w-4"
              @change="emitUpdate('protectInviteCode', $event.target.checked)"
            />
            <label for="protect-invite" class="text-sm text-neutral-700">
              Proteger enlace con codigo de invitacion
            </label>
          </div>

          <div class="flex items-center gap-3 mt-3">
            <label class="text-sm text-neutral-700">Codigo invite:</label>
            <input
              type="text"
              :value="inviteCode"
              class="rounded-md border border-neutral-300 px-3 py-2 text-sm text-neutral-700 bg-neutral-50"
              readonly
            />
            <div class="flex items-center gap-2">
              <input
                type="checkbox"
                :checked="limitInviteUses"
                id="limit-uses"
                class="h-4 w-4"
                @change="emitUpdate('limitInviteUses', $event.target.checked)"
              />
              <label for="limit-uses" class="text-sm text-neutral-700">
                Limitar a 50 usos
              </label>
            </div>
          </div>
        </div> -->

        <p class="text-sm text-neutral-500">
          Los estudiantes recibiran una solicitud para unirse a {{ inviteGroupName }}.
        </p>
      </div>

      <div class="flex justify-end gap-2 border-t border-neutral-200 px-6 py-4">
        <button
          class="rounded-md border border-neutral-300 px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50"
          @click="$emit('close')"
        >
          Cancelar
        </button>
        <button
          class="rounded-md bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700"
          @click="$emit('send')"
        >
          Enviar Invitaciones
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeacherInviteModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inviteGroupName: {
      type: String,
      default: "",
    },
    inviteEmails: {
      type: String,
      default: "",
    },
    inviteMessage: {
      type: String,
      default: "",
    },
    inviteLink: {
      type: String,
      default: "",
    },
    protectInviteCode: {
      type: Boolean,
      default: false,
    },
    inviteCode: {
      type: String,
      default: "",
    },
    limitInviteUses: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitUpdate(field, value) {
      this.$emit("update-field", { field, value });
    },
  },
};
</script>
